// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InventoryTransaction.yaml
// Generated: 2026-01-22T15:19:14.303Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateInventoryTransaction, UpdateInventoryTransaction, InventoryTransaction } from '@/types/inventory/InventoryTransaction';

/**
 * InventoryTransaction Service
 * CRUD operations for InventoryTransaction via the ABP API.
 */
export const inventoryTransactionService = new EntityService<InventoryTransaction, CreateInventoryTransaction, UpdateInventoryTransaction>(
  '/api/inventory/inventorytransaction',
  'InventoryTransaction',
);
